// extracted by mini-css-extract-plugin
export default {"root":"xnL_c","desktop":"fdtFu","maskFull":"yZyrR","smallMobile":"GJlnP","mobile":"TEYA1","tablet":"f3Xc_"};